import React from "react";
import { Navigate } from "react-router-dom";

export default function ProtectedFmsRoute({ children }) {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("adminRole");

  if (!token || role !== "fms") {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}